import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule }  from "@angular/forms";
// import { StripeModule } from "stripe-angular";
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './home/home.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { SocialLoginModule, AuthServiceConfig } from "angularx-social-login";
import { GoogleLoginProvider, FacebookLoginProvider } from "angularx-social-login";
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { NgHttpLoaderModule } from 'ng-http-loader';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { GoogleAnalyticsService } from './google-analytics.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DamComponent } from './dam/dam.component';
import { SigninComponent } from './signin/signin.component';
import { PricingComponent } from './pricing/pricing.component';
import { UploadComponent } from './upload/upload.component';
import { PeopleComponent } from './people/people.component';
import { PersonalComponent } from './personal/personal.component';
import { NewboardComponent } from './newboard/newboard.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { BoarddataComponent } from './boarddata/boarddata.component';
import { DropzonComponent } from './dropzon/dropzon.component';
// import { NgxDropzoneModule } from 'ngx-dropzone';
import { SettingsComponent } from './settings/settings.component';
import { CreateOrganisationComponent } from './create-organisation/create-organisation.component';
import { FaqComponent } from './faq/faq.component';
import { TermsComponent } from './terms/terms.component';
import { EnterpriseComponent } from './enterprise/enterprise.component';
import { EditboardComponent } from './editboard/editboard.component';
import { WorkspacesComponent } from './workspaces/workspaces.component';
import { MsalModule } from '@azure/msal-angular';
import { PublicClientApplication } from '@azure/msal-browser';
import { InviteUsersRegistreComponent } from './invite-users-registre/invite-users-registre.component';
import { InboxareaComponent } from './inboxarea/inboxarea.component';
import { VerificationComponent } from './verification/verification.component';
import { AllworkspacesComponent } from './allworkspaces/allworkspaces.component';
import { HomedetailsComponent } from './homedetails/homedetails.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { PaymentComponent } from './payment/payment.component';
import { SuccessComponent } from './success/success.component';
import { ShareComponent } from './share/share.component';
import { ShareboardComponent } from './shareboard/shareboard.component';
import { PickerModule } from "@ctrl/ngx-emoji-mart";
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { AppsComponent } from './apps/apps.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { FeaturesComponent } from './features/features.component';
import { TaggingComponent } from './tagging/tagging.component';
import { SharingComponent } from './sharing/sharing.component';
import { CheckoutComponent } from './checkout/checkout.component';
import { VersionComponent } from './version/version.component';
import { CollabComponent } from './collab/collab.component';
import { IntegrationComponent } from './integration/integration.component';
import { ArchiveComponent } from './archive/archive.component';
import { StorageComponent } from './storage/storage.component';
import { SearchComponent } from './search/search.component';
import { ApprovalsComponent } from './approvals/approvals.component';
import { PartnershipComponent } from './partnership/partnership.component';
import { MissionComponent } from './mission/mission.component';
import { ShowcaseComponent } from './showcase/showcase.component';
import { CommunityComponent } from './community/community.component';
import { DropAlterComponent } from './drop-alter/drop-alter.component';
import { DriveAlterComponent } from './drive-alter/drive-alter.component';
import { BoxAlterComponent } from './box-alter/box-alter.component';
import { TeamCollaborationComponent } from './team-collaboration/team-collaboration.component';
import { LearningComponent } from './learning/learning.component';
import { ProfileComponent } from './profile/profile.component';
import { MarketingComponent } from './marketing/marketing.component';
import { LibraryComponent } from './library/library.component';
import { PublicProfileComponent } from './public-profile/public-profile.component';
import { ContentLibraryComponent } from './content-library/content-library.component';
import { AboutComponent } from './about/about.component';
import { OfferCheckoutComponent } from './offer-checkout/offer-checkout.component';
import { OfferSignupComponent } from './offer-signup/offer-signup.component';
import { OfferAppsumoComponent } from './offer-appsumo/offer-appsumo.component';
import { WelcomeKitComponent } from './welcome-kit/welcome-kit.component';
import { VideosKitComponent } from './videos-kit/videos-kit.component';
import { InQueueComponent } from './in-queue/in-queue.component';
import { ProfilingComponent } from './profiling/profiling.component';
import { CelebrateSubscriberComponent } from './celebrate-subscriber/celebrate-subscriber.component';
import { MobileComponent } from './mobile/mobile.component';
import { BetaPgmComponent } from './beta-pgm/beta-pgm.component';
import { CompetitionComponent } from './competition/competition.component';
import { ViewCaseDesignComponent } from './view-case-design/view-case-design.component';
import { AffiliateComponent } from './affiliate/affiliate.component';
import { AiArtComponent } from './ai-art/ai-art.component';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;


let config = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider("555466977776-4f0b92s51tkr1pme5cvt74c7srnqt537.apps.googleusercontent.com")
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider("248686746478971")
  }
]);

export function provideConfig() {
  return config;
}

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    ContactUsComponent,
    DamComponent,
    SigninComponent,
    PricingComponent,
    UploadComponent,
    PeopleComponent,
    PersonalComponent,
    NewboardComponent,
    SubscriptionComponent,
    BoarddataComponent,
    DropzonComponent,
    SettingsComponent,
    CreateOrganisationComponent,
    FaqComponent,
    TermsComponent,
    EnterpriseComponent,
    EditboardComponent,
    WorkspacesComponent,
    InviteUsersRegistreComponent,
    InboxareaComponent,
    VerificationComponent,
    AllworkspacesComponent,
    HomedetailsComponent,
    MaintenanceComponent,
    PaymentComponent,
    SuccessComponent,
    ShareComponent,
    ShareboardComponent,
    AppsComponent,
    FeedbackComponent,
    FeaturesComponent,
    TaggingComponent,
    SharingComponent,
    CheckoutComponent,
    VersionComponent,
    CollabComponent,
    IntegrationComponent,
    ArchiveComponent,
    StorageComponent,
    SearchComponent,
    ApprovalsComponent,
    PartnershipComponent,
    MissionComponent,
    ShowcaseComponent,
    CommunityComponent,
    DropAlterComponent,
    DriveAlterComponent,
    BoxAlterComponent,
    TeamCollaborationComponent,
    LearningComponent,
    ProfileComponent,
    MarketingComponent,
    LibraryComponent,
    PublicProfileComponent,
    ContentLibraryComponent,
    AboutComponent,
    OfferCheckoutComponent,
    OfferSignupComponent,
    OfferAppsumoComponent,
    WelcomeKitComponent,
    VideosKitComponent,
    InQueueComponent,
    ProfilingComponent,
    CelebrateSubscriberComponent,
    MobileComponent,
    BetaPgmComponent,
    CompetitionComponent,
    ViewCaseDesignComponent,
    AffiliateComponent,
    AiArtComponent,
  ],
  imports: [
    BrowserModule,
    NgxCaptchaModule,
    FormsModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    SocialLoginModule,
    ReactiveFormsModule,
    NgHttpLoaderModule.forRoot(),
    InfiniteScrollModule,
    PickerModule,
    PdfViewerModule,
    BrowserAnimationsModule,
    MatTooltipModule,
    // NgxDropzoneModule,
    // StripeModule.forRoot(environment.STRIPE_LIVE_KEY),
    MsalModule.forRoot( new PublicClientApplication({
      auth: {
        clientId: environment.MICROSOFT_CLIENT_ID,
        authority: 'https://login.microsoftonline.com/common',
        redirectUri: environment.MICROSOFT_REDIRECTION_URL,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: isIE,
      }
    }), null, null)
  ],
  providers: [
    GoogleAnalyticsService,
    {
      provide: AuthServiceConfig,
      useFactory: provideConfig,
    },
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
